import {acBrandTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = acBrandTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const acBrandReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default acBrandReducer;
